import { createClient as createSupabaseClient } from '@supabase/supabase-js';

export const PRODUCTION_ORIGIN = 'https://kheldrop.com';

export function getAuthRedirectUrl(path: string = '/auth/callback'): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (typeof window !== 'undefined' && window.location.origin) {
    return `${window.location.origin}${normalizedPath}`;
  }
  return `${PRODUCTION_ORIGIN}${normalizedPath}`;
}

// Browser Supabase client (ported from @supabase/ssr createBrowserClient).
export function createClient() {
  const supabaseUrl =
    process.env.REACT_APP_SUPABASE_URL ||
    process.env.NEXT_PUBLIC_SUPABASE_URL ||
    'https://cjvyekcdazzlkdzxzepm.supabase.co';
  const supabaseKey =
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
    'sb_publishable_jYJa_y7N9Q0luqiMLJAyeg_HNCBRR7W';

  return createSupabaseClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

